module.exports = __webpack_public_path__ + "img/ARM_Logo_White.d8ef3d6f.png";